import "./retailerFinance.css";
import React, { useCallback, useEffect } from "react";
import { useState } from "react";
import { Grid, Box, Button, LoadingOverlay, Text } from "@mantine/core";
import { Heading } from "../heading/heading";
import { bankListType, popupType } from "../../../types/types";
import { getCheckedBanks, getMetadata, submitSelectedBank, submitSelectedBankForAccountSharing, updateSelectedBankForAccountSharing } from "../../../services/bankingService";
import { useAuth } from "../../../providers/AuthProvider";
import { GenericPopUp } from "../../popup/genericPopUp";
import { PaymentMethodTiles } from "./retailerHelper/PaymentMethodTiles";
import { InfoCircle } from "tabler-icons-react";

export function RetailerFinance() {
  const authContext = useAuth();
  const[bankList, setbankList] = useState<bankListType[]>([]);
  const[bankListSharing, setBankListSharing] = useState<bankListType[]>([]);

  const fetchBankListForAccountSharing = useCallback ( async () => {
    setLoaderShowOnCreateAccount(true);
    const metaDataResponse = await getMetadata();
    const bankListResponseForAccountSharing = metaDataResponse.features.filter( (j:any) => (j.domainName === "clientconfig" && j.domainType === "sharingBankDetails"));    

    const domainBankListForAccountSharing = bankListResponseForAccountSharing[0].domainValues;
    let newList : bankListType[] = [];
    newList = domainBankListForAccountSharing;
    newList.forEach(eachElementofBank => {
      if(!eachElementofBank.checked){
        eachElementofBank.checked = false;
      }
      if(!eachElementofBank.disabled){
        eachElementofBank.disabled=true;
      }
    })

    setLoaderShowOnCreateAccount(false);
    await setBankListSharing(newList);
    return newList;
  
  },[authContext])

  const fetchBankList = useCallback ( async () => {
    setLoaderShowOnCreateAccount(true);
    const metaDataResponse = await getMetadata();
    const bankListResponse = metaDataResponse.features.filter( (j:any) => (j.domainName === "clientconfig" && j.domainType === "bankList"));

    const domainBankList = bankListResponse[0].domainValues;
    
    let newList : bankListType[] = [];
    newList = domainBankList;
    newList.forEach(eachElementofBank => {
      if(!eachElementofBank.checked){
        eachElementofBank.checked = false;
      }
    })

    setLoaderShowOnCreateAccount(false);
    await setbankList(newList);
    return newList;
  
  },[authContext])

  const sharedDetailsBanks = useCallback ( async(BL: bankListType[]) =>{
    setLoaderShowOnCreateAccount(true);
    try{
      let sharedDetailsBanksResponse = await getCheckedBanks();
      let updatedBankList = [...BL];
      sharedDetailsBanksResponse.forEach((sharedBank: { paymentProvideType: string, status:string })=>{
        const enrolledBankIdx = updatedBankList.findIndex(bank => bank.id === sharedBank.paymentProvideType)
        if(enrolledBankIdx !== -1) {
          updatedBankList[enrolledBankIdx].disabled=false
          if(sharedBank.status === "ACTIVE"){
            updatedBankList[enrolledBankIdx].checked = true
          }
        }
      })
      setLoaderShowOnCreateAccount(false);
      setBankListSharing(updatedBankList);
      return updatedBankList;
    }catch(e:any){
      openPopup(e.response.message, "Error");
    }
},[ authContext])

  const enrolledBanksApiCall = useCallback ( async(BL: bankListType[]) =>{
    setLoaderShowOnCreateAccount(true);
    try{
      let enrolledBanksResponse = await getCheckedBanks();
      
      let updatedBankList = [...BL];
      enrolledBanksResponse.forEach((enrolledBanksResponseData: { paymentProvideType: string; })=>{
        const enrolledBankIdx = updatedBankList.findIndex(bank => bank.id === enrolledBanksResponseData.paymentProvideType)
        if(enrolledBankIdx !== -1) {
          updatedBankList[enrolledBankIdx].checked = true
        }
      })
      setLoaderShowOnCreateAccount(false);
      setbankList(updatedBankList);
      return updatedBankList;
    }catch(e:any){
      openPopup(e.response.message, "Error");
    }
},[authContext])

  useEffect(() => {
    const method = async () => {
    let x: bankListType[] = await fetchBankList();
    await enrolledBanksApiCall(x);
    let y: bankListType[] = await fetchBankListForAccountSharing();
    await sharedDetailsBanks(y);
  }
  method();
    
    },[ fetchBankList, enrolledBanksApiCall, sharedDetailsBanks,fetchBankListForAccountSharing]);

  const [checkedRetailers, setCheckedRetailers] = useState<string>("");
  const [checkRetailerSharingDetails, setCheckRetailerSharingDetails] = useState<string>("");
  const [loaderShowOnCreateAccount, setLoaderShowOnCreateAccount] = useState<boolean>(false);
  const [openGenericModal, setOpenGenericModal] = useState(false);
  const [popupType, setPopupType] = useState<popupType>("Alert");
  const [genericMessage,setGenericMessage] = useState("");


  const apiBodyLoginid = {
    loginId: JSON.parse(localStorage.authContext).user.loginId,
  };

  const accountDetailsLoginid = {
    loginId: JSON.parse(localStorage.authContext).user.loginId,
    paymentPhase: "ACCOUNT_ENROLLMENT"
  }

  const openPopup = (message:string, type:popupType)=>{
    setPopupType(type)
    setGenericMessage(message)
    setOpenGenericModal(true)
  }

  const callBankSharing=async (sharedBank:any,checkRetailerSharingDetails:any)=>{
    if(sharedBank.paymentProvideType !== checkRetailerSharingDetails) return;
    try{
    let submitSelectedBankResponse:any;
    if(sharedBank.status.toUpperCase() === "ACCOUNT_DETAILS_UPDATED"){
      submitSelectedBankResponse = await updateSelectedBankForAccountSharing(
        accountDetailsLoginid,
        checkRetailerSharingDetails
      );
     
  }else{
    submitSelectedBankResponse = await submitSelectedBankForAccountSharing(
    accountDetailsLoginid,
    checkRetailerSharingDetails
  )
  }
  submitSelectedBankResponse && response(submitSelectedBankResponse);
    }
    catch (e: any) {
      setLoaderShowOnCreateAccount(false);
      if(e?.response?.data?.statusDesc){
      openPopup(e?.response?.data?.statusDesc,"Error")
      }else{
        openPopup(e?.data?.message,"Error")
      }
    }
  }
  

  const response = (submitSelectedBankResponse:any) => {
    if (submitSelectedBankResponse!.status === "FAILURE") {
      openPopup(submitSelectedBankResponse!.statusDesc, "Error");
    } else {
      openPopup("Successfully shared bank details with bank", "Success");
      enrolledBanksApiCall(bankList);
      sharedDetailsBanks(bankListSharing);
    }
    setLoaderShowOnCreateAccount(false);
  }

  const submitAccountDetails = async () => {
    setLoaderShowOnCreateAccount(true);
    if(checkRetailerSharingDetails.length > 0){
      
        let sharedDetailsBanksResponse = await getCheckedBanks();
        sharedDetailsBanksResponse.forEach( (sharedBank: { paymentProvideType: string, status:string })=>{
           callBankSharing(sharedBank,checkRetailerSharingDetails);
        })
       
    } else {
      openPopup("Please choose a bank to share details", "Alert")
    }
    setLoaderShowOnCreateAccount(false);
    };
  
  const submitForm = async () => {
    setLoaderShowOnCreateAccount(true);
    if (checkedRetailers.length > 0) {
      let submitSelectedBankResponse;
      try {
        submitSelectedBankResponse = await submitSelectedBank(
          apiBodyLoginid,
          checkedRetailers
        );
        if (submitSelectedBankResponse.status === "FAILURE") {
          openPopup(submitSelectedBankResponse.statusDesc, "Error");
        } else {
          openPopup(`Successfully Enrolled in ${checkedRetailers}`, "Success");
          enrolledBanksApiCall(bankList);
          sharedDetailsBanks(bankListSharing);
        }
        setLoaderShowOnCreateAccount(false);
      } catch (e: any) {
        setLoaderShowOnCreateAccount(false);
        if(e?.response?.data?.statusDesc){
        openPopup(e?.response?.data?.statusDesc,"Error")
        }else{
          openPopup(e?.data?.message,"Error")
        }
      }
    } else {
      openPopup("Please choose a bank to enroll in", "Alert")
      setLoaderShowOnCreateAccount(false);
    }
  };
  
  return (
    <div className="app-container">
      {loaderShowOnCreateAccount && (
        <LoadingOverlay
          visible={loaderShowOnCreateAccount}
          style={{ position: "fixed" }}
        />
      )}

    <GenericPopUp message={genericMessage}
      type={popupType}
      openGenericModal={openGenericModal}
      setOpenGenericModal={setOpenGenericModal} />

      <Box className="mainBox">
        <Box className="headingAndTilesContainer">
          <Heading mainHeading="Enroll to retailer finance" />
          <Box className="tiles">
            <Grid>
              {bankList
                .filter((obj) => obj.checked)
                .map((obj) => (
                  <PaymentMethodTiles
                    id={obj.id}
                    name={obj.name}
                    image={obj.image}
                    disabled={obj.checked}
                    checkedRetailers={checkedRetailers}
                    setCheckedRetailers={setCheckedRetailers}
                  />
                ))}
              {bankList
                 .filter((obj) => !obj.checked)
                .map((obj) => (
                  <PaymentMethodTiles
                    id={obj.id}
                    name={obj.name}
                    image={obj.image}
                    checkedRetailers={checkedRetailers}
                    setCheckedRetailers={setCheckedRetailers}
                  />
                ))}
            </Grid>
          </Box>
        </Box>
        <Box
          sx={() => ({
            textAlign: "center",
            marginBottom: "40px",
            marginTop: "50px",
          })}
        >
          <Button style={{ backgroundColor: "#02BBd5" }} onClick={submitForm}>
            Submit
          </Button>
        </Box>
      </Box>
      <Box
            sx={(theme) => ({
              height: "50px",
              display: "flex",
              alignContent: "flex-end",
              alignItems: "flex-end",
              justifyContent: "flex-end"
            })}
          >
            <Box 
            >
            <Text color="black" size="sm" ml={6}>
            <InfoCircle size={17} strokeWidth={2} color={"black"} />
                    &nbsp;Your account details are yet to be shared with SBI. Mark the check box to share your bank details. 👇
            </Text>
            </Box>
            </Box>
            <Box className="mainBox">
              <Box className="headingAndTilesContainer">
                <Heading mainHeading="Sharing bank details" />
                <Box className="tiles">
            <Grid>
              {bankListSharing
                .filter((obj) => obj.checked)
                .map((obj) => (
                  <PaymentMethodTiles
                    id={obj.id}
                    name={obj.name}
                    disabled={obj.checked}
                    image={obj.image}
                    checkRetailerSharingDetails={checkRetailerSharingDetails}
                    setCheckRetailerSharingDetails={setCheckRetailerSharingDetails}
                  />
                ))}
                {bankListSharing
                .filter((obj) => !obj.checked)
                .map((obj) => (
                  <PaymentMethodTiles
                    id={obj.id}
                    name={obj.name}
                    image={obj.image}
                    checkRetailerSharingDetails={checkRetailerSharingDetails}
                    setCheckRetailerSharingDetails={setCheckRetailerSharingDetails}
                    isDivDisabled={obj.disabled}
                  />
                ))}
                </Grid>
                </Box>
              </Box>
            </Box>
            <Box
          sx={() => ({
            textAlign: "center",
            marginBottom: "40px",
            marginTop: "50px",
          })}
        >
          <Button style={{ backgroundColor: "#02BBd5" }} onClick={submitAccountDetails}>
            Submit
          </Button>
        </Box>
    </div>
  );
}


 